import Vue from 'vue';
import SectionTitle from './section-title.vue';
import ContactInformation from './footer.vue';
Vue.component('ContactInformation',ContactInformation);
Vue.component('SectionTitle',SectionTitle);